

// const contribution: Contribution = {
//   date: admin.firestore.Timestamp.fromDate(new Date()), // Convert JavaScript Date to Firestore Timestamp

export class Contribution {
    userId: string;
    minutes: number;
    date: Date;
  
    constructor(userId: string, minutes: number, date: Date) {
      this.userId = userId;
      this.minutes = minutes;
      this.date = date;
    }

    toPOJO(){
      return{
        userId: this.userId,
        minutes: this.minutes,
        date: this.date.toISOString()
      }
    }
    toObject() {
      return {
        userId: this.userId,
        minutes: this.minutes,
        date:this.date.toDateString()
      }
    }

    static createFromObject(data: Contribution){
      const {
        userId,
        minutes,
        date,
      } = data;
  
      const cont = new Contribution(userId, minutes, date);
      return cont;
    }

    static compare(contribution: any, other: any):boolean{
      return contribution.userId === other.userId && 
      contribution.minutes === other.minutes &&
      contribution.date === other.date
    }
  }

  export default Contribution;